import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useCorporateStore = defineStore({
    id: 'corporate',
    state: () => ({
        headerList: ['Corporate Packages', 'Check Up Services', 'Vaccinations', 'Telemedicines'],
        eggDescList: [
            {
                eggIconObj: { componentName: 'corporate', imgName: 'heart', imgFormat: 'svg', width: '4.6vw' },
                label: 'corporate.customHealthBeneDesc'
            },
            {
                eggIconObj: { componentName: 'corporate', imgName: 'lightblub', imgFormat: 'svg', width: '3vw' },
                label: 'corporate.onSiteSolDesc'
            },
            {
                eggIconObj: { componentName: 'corporate', imgName: 'note', imgFormat: 'svg', width: '4.6vw' },
                label: 'corporate.medicalClaimDesc'
            }
        ],
        photoDescList: [
            {
                id: 'wellInit',
                label: 'corporate.wellInitTitle',
                description: 'corporate.wellInitDesc',
                image: { componentName: 'corporate', imgName: 'wellInit', imgFormat: 'svg' },
            },
            {
                id: 'healthAnalytics',
                label: 'corporate.healthAnalyticsTitle',
                description: 'corporate.healthAnalyticsDesc',
                image: { componentName: 'corporate', imgName: 'healthAnalytics', imgFormat: 'svg' },

            },
            {
                id: 'employHealhMan',
                label: 'corporate.employHealhManTitle',
                description: 'corporate.employHealhManDesc',
                image: { componentName: 'corporate', imgName: 'employHealhMan', imgFormat: 'svg' },

            },
            {
                id: 'medicalAdvisory',
                label: 'corporate.medicalAdvisoryTitle',
                description: 'corporate.medicalAdvisoryDesc',
                image: { componentName: 'corporate', imgName: 'medicalAdvisory', imgFormat: 'svg' },

            }
        ]

    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCorporateStore, import.meta.hot));
}

export { useCorporateStore };
